import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './locales/en/translation';
import cy from './locales/cy/translation';

const resources = {
  en: {
    translation: en,
  },
  cy: {
    translation: cy
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    detection: {
      order: ['querystring', 'localStorage'],
      lookupQuerystring: 'lang',
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage']
    },
    debug: false,
    keySeparator: '.',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    },
    useSuspense: false
  });

export default i18n;
